var exports = {
  "b": "Root__sc5Ixo",
};

module.exports = exports;
